import app from '@/router/modules/app';
import logInSignUp from '@/router/modules/log-in-sign-up';
import employer from '@/router/modules/employer';
import worker from '@/router/modules/worker';

const routes = [...app, ...logInSignUp, ...employer, ...worker];

export default routes;
